import { isDateInRange } from './dateRangeUtils';

export function extractReportRows(payload) {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.data)) return payload.data;
  const nested = Object.values(payload).filter(Array.isArray);
  return nested[0] || [];
}

export function aggregateCampaignSpend(rows, startDate, endDate) {
  const map = {};
  (rows || []).forEach((row) => {
    if (startDate && endDate && !isDateInRange(row.date, startDate, endDate)) return;
    const campId = String(row.campaignId || '');
    if (!campId) return;
    map[campId] = (map[campId] || 0) + (row.cost || 0);
  });
  return map;
}

/** Per-campaign cost + attributed sales for the selected date range. */
export function aggregateCampaignMetrics(rows, startDate, endDate) {
  const map = {};
  (rows || []).forEach((row) => {
    if (startDate && endDate && !isDateInRange(row.date, startDate, endDate)) return;
    const campId = String(row.campaignId || '');
    if (!campId) return;
    if (!map[campId]) {
      map[campId] = { cost: 0, sales: 0, clicks: 0, impressions: 0, name: row.campaignName || '' };
    }
    const bucket = map[campId];
    bucket.cost += Number(row.cost) || 0;
    bucket.sales += Number(row.sales14d ?? row.sales ?? row.attributedSales14d) || 0;
    bucket.clicks += Number(row.clicks) || 0;
    bucket.impressions += Number(row.impressions) || 0;
    if (row.campaignName) bucket.name = row.campaignName;
  });
  return map;
}
